/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, message, Drawer, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, saveBarangayEquipmentLookup, onClose, isEdit, selectedEquipment } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}
			let params = Object.assign({}, values, { barangay_uid })
			if (isEdit && selectedEquipment) {
				params = Object.assign({}, params, { equipment_lookup_uid: selectedEquipment.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_equipment', content: 'Saving facility, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveBarangayEquipmentLookup(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_equipment', content: 'Equipment successfully saved.' })
					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving equipment')
					message.error({ key: 'set_equipment', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, selectedEquipment } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Drawer
				title="Manage Equipments"
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
				bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Name of Equipment'>
							{ getFieldDecorator('name', {
								initialValue: (selectedEquipment) ? selectedEquipment.name : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Equipment name'/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Description'>
							{ getFieldDecorator('description', {
								initialValue: (selectedEquipment) ? selectedEquipment.description : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter Description'/>
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const SET_BARANGAY_EQUIPMENT_LOOKUP = gql`
    mutation setBarangayEquipmentLookup($input: JSON) {
		setBarangayEquipmentLookup(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-barangay-equipment-lookup' }),
	inject('AuthStore'),
	graphql(SET_BARANGAY_EQUIPMENT_LOOKUP, {
		props({ mutate }) {
			return {
				saveBarangayEquipmentLookup(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayEquipmentsLookup']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
